import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, fontSize, fontWeight, TypographyStyledGlobal } from '../../../theme';
import { Evolution, EvolutionLegendKind } from '../dashboardInterfaces';
import { EVOLUTION_ICONS } from '../IndicatorCard/evolution';
import { EvolutionLegendIconsStyled, EvolutionLegendStyled } from './styled';

type EvolutionLegendProps = {
    kind: EvolutionLegendKind
}

const ICON_SIZE = 12;

const LEGEND_LABELS = {
    [EvolutionLegendKind.GLOBAL]: 'evolutionLegend.global',
    [EvolutionLegendKind.PERIOD]: 'evolutionLegend.period',
    [EvolutionLegendKind.TOTAL]: 'evolutionLegend.total',
} as const;

const EvolutionLegend: FC<EvolutionLegendProps> = ({ kind }) => {
    const { t } = useTranslation('dashboard');
    // Same icons as the indicators: up and down against another period,
    // positive and negative against the whole base or the total column.
    const [HigherIcon, LowerIcon] = kind === EvolutionLegendKind.PERIOD
        ? [EVOLUTION_ICONS[Evolution.UP], EVOLUTION_ICONS[Evolution.DOWN]]
        : [EVOLUTION_ICONS[Evolution.POSITIVE], EVOLUTION_ICONS[Evolution.NEGATIVE]];

    return (
        <EvolutionLegendStyled>
            <EvolutionLegendIconsStyled>
                <HigherIcon height={ICON_SIZE} width={ICON_SIZE} />
                <LowerIcon height={ICON_SIZE} width={ICON_SIZE} />
            </EvolutionLegendIconsStyled>
            <TypographyStyledGlobal color={colors.grey400} fontWeight={fontWeight.semiRegular} size={fontSize.s}>
                {t(LEGEND_LABELS[kind])}
            </TypographyStyledGlobal>
        </EvolutionLegendStyled>
    );
};

export default EvolutionLegend;
